import { Manager } from "socket.io-client";
import _config from "./config";

export const manager = new Manager(_config.socket_server_uri, {
    reconnectionDelayMax: 10000,
    reconnection: true,
    transports: ["websocket"],
});
